/**
 * Hook to fetch channels linked to an agent configuration
 */

import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AgentChannel, agentsApi } from "../api";

export const useAgentChannels = (
  agentConfigId: string
): UseQueryResult<AgentChannel[], Error> => {
  return useQuery<AgentChannel[], Error>({
    queryKey: ["ai-studio", "agents", agentConfigId, "channels"],
    queryFn: () => agentsApi.listChannels(agentConfigId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2,
    enabled: !!agentConfigId
  });
};
